import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../BrandLogo';

function Register() {
  return (
    <main style={styles.container}>
      <section style={styles.card} aria-labelledby="register-title">
        <Link to="/" style={styles.backLink}>← Back to Home</Link>
        <div style={styles.logo}><BrandLogo /></div>
        <p style={styles.eyebrow}>One secure identity</p>
        <h1 id="register-title" style={styles.title}>Create your Inframodule account</h1>
        <p style={styles.copy}>
          Use one verified account across Inframodule products. Your Cloudnotes membership starts
          on the Free plan immediately, with optional paid upgrades later.
        </p>
        <a href="/api/auth/sso/login" className="internal-primary-action" style={styles.primary}>Continue with Inframodule</a>
        <p style={styles.footer}>
          Already have a legacy Cloudnotes account? <Link to="/login" style={styles.link}>Sign in and link it</Link>
        </p>
        <p style={styles.product}>A product of Inframodule</p>
      </section>
    </main>
  );
}

const styles = {
  container: {
    minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '24px', background: '#f3f9fc',
  },
  card: {
    width: 'min(100%, 480px)', boxSizing: 'border-box', padding: '40px', border: '1px solid #d9e9f2',
    borderRadius: '20px', background: '#fff', boxShadow: '0 18px 48px rgba(6, 27, 46, 0.1)',
  },
  backLink: { color: '#04658f', textDecoration: 'none', fontSize: '14px' },
  logo: { display: 'flex', justifyContent: 'center', margin: '28px 0' },
  eyebrow: {
    margin: '0 0 8px', color: '#04658f', fontSize: '12px', fontWeight: '800',
    letterSpacing: '0.12em', textTransform: 'uppercase',
  },
  title: { margin: 0, color: '#061b2e', fontSize: '2.1rem', lineHeight: 1.08 },
  copy: { margin: '18px 0 26px', color: '#52677c', lineHeight: 1.65 },
  primary: {
    display: 'block', padding: '14px 18px', borderRadius: '9px', color: '#fff', background: '#0778ad',
    fontWeight: '700', textAlign: 'center', textDecoration: 'none',
  },
  footer: { margin: '22px 0 0', color: '#52677c', fontSize: '14px', lineHeight: 1.5 },
  link: { color: '#04658f', fontWeight: '700' },
  product: { margin: '26px 0 0', color: '#7d8fa0', fontSize: '12px', textAlign: 'center' },
};

export default Register;
